import restClient from "./RestClient";
import {RoadInfrastructureRouteEntity} from "./entities/replancity_RoadInfrastructureRoute";
import type * as schema from './schema';

export const roadManagementApi = {
  groupUpdate: function (
      data: schema.paths["/services/replancity_RoadInfrastructureService/groupSaveAndUpdateV2"]["get"]["parameters"]["query"],
      abortSignal: AbortSignal
  ):
      Promise<any[]> {
    return restClient.fetch({
      method: "POST",
      path: `services/replancity_RoadInfrastructureService/groupSaveAndUpdateV2`,
      data,
      fetchOptions: {signal: abortSignal}
    });
  },

  groupManipulate: function (
      data: {
        task: {
          presetId: string;
          type: 'DELETE';
          targets: string[];
        }
      },
      abortSignal: AbortSignal
  ):
      Promise<void> {
    return restClient.fetch({
      method: "POST",
      path: `services/replancity_RoadInfrastructureService/groupManipulate`,
      data,
      fetchOptions: {signal: abortSignal}
    });
  },

  getModes: function (
    data: schema.paths["/services/replancity_RoadInfrastructureService/listAllModes"]["get"]["parameters"]["query"],
    abortSignal: AbortSignal
  ):
    Promise<string[]> {
    return restClient.fetch({
      method: "GET",
      path: `services/replancity_RoadInfrastructureService/listAllModes`,
      data,
      fetchOptions: {signal: abortSignal}
    });
  },

  calculateAndGetRouteGeometry: function (
      data: schema.paths["/services/replancity_RoadInfrastructureService/calculateRoute"]["get"]["parameters"]["query"],
      abortSignal: AbortSignal
  ):
      Promise<RoadInfrastructureRouteEntity> {
    return restClient.fetch({
      method: "GET",
      path: "services/replancity_RoadInfrastructureService/calculateRoute",
      data,
      fetchOptions: {signal: abortSignal}
    });
  },

  listAllHighways: function (
      data: schema.paths["/services/replancity_RoadInfrastructureService/listAllHighways"]["get"]["parameters"]["query"],
      abortSignal: AbortSignal
  ):
      Promise<{id: string; name: string;}[]> {
    return restClient.fetch({
      method: "GET",
      path: `services/replancity_RoadInfrastructureService/listAllHighways`,
      data,
      fetchOptions: {signal: abortSignal}
    });
  },

}